<template>
    <v-row>
      <v-col :cols="12" :lg="cols">
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="label"
          :items="filteredOptions "
          :value.sync="formModel.subPartyRoleId"
          item-text="name"
          item-value="id"
          item-disabled="disabled"
          :validates="validates"
          :disabled="false"
        />
      </v-col>
    </v-row>
</template>
<script>
export default {
  name: 'PartyRole',
  inject: ['$validator'],
  props: {
    formModel:      { type: Object, required: true },
    options:        { type: Array, default: () => [] },
    existingParties:{ type: Array,   default: () => [] },
    label:          { type: String,  default: '' },
    required:       { type: Boolean, default: false },
    noBottomMargin: { type: Boolean, default: false },
    noHGutters:     { type: Boolean, default: false },
    cols:           { type: [Number, String], default: 3 },
    isViewMode:     { type: Boolean, default: false }
  },
  computed: {
    validates() {
      return (this.required) ? 'required' : '';
    },
    filteredOptions() {
      const usedIds = this.existingParties
        .map((p) => p.subPartyRoleId)
        .filter((id) => id != null);
      return this.options.map((role) => ({
        ...role,
        disabled: !role.isMultiple && usedIds.includes(role.id),
      }));
    },
  },
};
</script>
<style scoped>
.party-role-row {
  margin-top: 1rem;
}
</style>